<template>
    <div class="loginBox">
        <!-- <div class="login-QRcode">
            <img :src="require('../../assets/images/QRcode.png')" alt="">
            <div>安卓APP下载</div>
        </div> -->
        <div class="login-container" style="border-radius: 15px">
            <el-form ref="loginForm" class="BOX" id="login-form" aria-autocomplete="no" :model="loginForm" :rules="loginRules" label-width="0.8rem" hide-required-asterisk>
                <div class="title-container">
                    <h4>密码登录</h4>
                </div>
                <el-form-item prop="username" label="登录账号">
                    <el-input name="username" type="text" v-model="loginForm.username" autoComplete="on" placeholder="邮箱/会员名/8位ID"></el-input>
                </el-form-item>
                <el-form-item prop="password" label="登录密码">
                    <el-input name="password" type="password" v-model="loginForm.password" autoComplete="on" placeholder="请输入登录密码"></el-input>
                </el-form-item>
                <el-form-item prop="codeRandom" label="验证码">
                    <el-input style="width: 50%;" type="text" v-model="loginForm.codeRandom" autoComplete="on" placeholder="请输入验证码"></el-input>
                    <img :src="imgUrl" alt="" @click="getRandom()" style="width: 0.95rem;height: 0.25rem;cursor: pointer;display: inline-block;background: #ccc;">
                </el-form-item>
                <el-button type="primary" style="width: 100%;margin-bottom: 0.22rem;" :loading='loading' @click.native.prevent="handleLogin">登录</el-button>
                <div class="outerDiv">
<!--                    <el-link style="margin-right: 0.1rem;" @click="jump('forgetPass')">忘记密码</el-link>-->
                    <el-link @click="jump('register')">注册</el-link>
                </div>
<!--                <div>
                    <span>其他登录方式：</span>
                    &lt;!&ndash; <img v-for="(v, i) of List" :key="i" :src="v.imgUrl" alt="" style="margin-right: 0.1rem;cursor: pointer;" @click="change(i)"> &ndash;&gt;
                    <img :src="require('../../assets/images/qq_icon.png')" id="qqLoginBtn" @click="qqLoginClick('qq')" style="margin-right: 0.1rem;cursor: pointer;">
                </div>-->
            </el-form>
            <div class="BOX" id="QRcode">
                <div>
                    <div class="titleBox">
                        <span>{{title}}</span>
                        <i class="el-icon-close" style="cursor: pointer;" @click="close()"></i>
                    </div>
                    <div class="con">
                        <img :src="CodeUrl" alt="">
                        <div>
                            <img :src="saoma" alt="">
                            <div>
                                <span>打开{{subtit}}</span>
                                <span>扫一扫完成登录</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
<!--        <div class="download-QRcode">
            <div>
                &lt;!&ndash; <img class="QRcode-Img" :src="VQrCodeImage" alt=""> &ndash;&gt;
                <div id="qrcode"></div>
                <div v-if="VQrCodeImage" style="text-align: center;">安卓APP下载</div>
            </div>
            <div>
                 &lt;!&ndash; <img class="QRcode-Img" :src="VQrCodeImageIos" alt=""> &ndash;&gt;
                <div id="qrcodeIphone"></div>
                <div v-if="VQrCodeImageIos" style="text-align: center;">苹果APP下载</div>
             </div>
        </div>-->
    </div>

</template>

<script>
import $ from 'jquery'
import QRCode from 'qrcodejs2'
import CryptoJS from "@/untils/CryptoJS";
import {jump, setUser, getTokenKey, removeTokenKey, ValidatePassWord, getUser} from '../../untils/auth'
export default {
    name: 'Login',
    data() {
        const validateUsername = (rule, value, callback) => {
            if (value.length < 1) {
                callback(new Error('用户名不能少于1位'));
            } else {
                callback()
            }
        }
        const validatePassword = (rule, value, callback) => {
            if (value == 123 ) {
                this.$message.error("密码过于简单!");
            }
            // if(!value){
            //     callback(new Error('密码不能为空'))
            // }else if(!ValidatePassWord(value)){
            //     callback(new Error('密码格式不正确'));
            // } else{
            //     callback();
            // }
            if(!value){
                callback(new Error('密码不能为空'))
            }else{
                callback();
            }
        };
        return {
            loading: false,
            loginForm: {
                username: '',
                password: '',
                codeRandom: ''
            },
            loginRules: {
                username: [{ required: true, trigger: 'blur', validator: validateUsername }],
                password: [{ required: true, trigger: 'blur', validator: validatePassword }],
                codeRandom: [{ required: true, message: '请输入验证码', trigger: 'blur' },]
            },
            List: [
                {
                    id: 'qqLoginBtn',
                    imgUrl: require('../../assets/images/qq_icon.png'),
                    title: 'QQ登录',
                    CodeUrl: require('../../assets/images/erweima.png'),
                    subtit: 'QQ手机版'
                },
                {
                    id: '',
                    imgUrl: require('../../assets/images/weixin_icon.png'),
                    title: '微信登录',
                    CodeUrl: require('../../assets/images/erweima.png'),
                    subtit: '微信'
                },
                {
                    id: '',
                    imgUrl: require('../../assets/images/xinlang_icon.png'),
                    title: '微博登录',
                    CodeUrl: require('../../assets/images/erweima.png'),
                    subtit: '新浪微博'
                }
            ],
            title: '',
            CodeUrl: '',
            subtit: '',
            saoma: require('../../assets/images/saoma.png'),
            imgUrl: '',
            VQrCodeImage: '',
            VQrCodeImageIos: ''
        }
    },
    created() {
        this.getRandom()
        this.getInfo()
    },
    methods: {
        // 生成二维码
        getInfo() {
            let _this = this;
            // 获取页头和页脚信息
            this.axios.post(window.IPConfig.IP + '/tBAppVersion/queryPage.do?',{
                VSystemId: this.$store.state.user.VSystemId
            }).then((response) =>{
                if(response.status == 200){
                    if(response.data.status == 200){
                        let qrCodes = response.data.obj.records;
                        if(qrCodes.length){
                            qrCodes.forEach(item => {
                                if(item.TContent){
                                    if(item.TContent.indexOf('安卓') != -1){
                                        this.VQrCodeImage = item.TAddress;
                                    }else{
                                        this.VQrCodeImageIos = item.TAddress;
                                    }
                                }
                            })
                        }
                        //this.VQrCodeImage = response.data.obj.VSystemUrl;
                        //this.VQrCodeImageIos = response.data.obj.VSystemUrl;
                        // 生成二维码
                        this.$nextTick(() => {
                            _this.crateQrcode()
                        })
                    }
                }
            })
        },
        // 生成二维码
        crateQrcode () {
            this.qr = new QRCode('qrcode', {
                width: 150,
                height: 150, // 高度
                text: this.VQrCodeImage // 二维码内容
                // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
                // background: '#f0f'
                // foreground: '#ff0'
            });
            this.qr2 = new QRCode('qrcodeIphone', {
                width: 150,
                height: 150, // 高度
                text: this.VQrCodeImageIos // 二维码内容
                // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
                // background: '#f0f'
                // foreground: '#ff0'
            })
        },
        qqLoginClick (value) {
            // this.href()
            QC.Login.showPopup({
                appId: '101814999',
                redirectURI: `${window.IPConfig.IP}/#/login/index`
            })

        },
        // 第三方登录
        href () {
                // 弹出 500 * 500 的窗口
                window.open(this.githubUrl, 'newwindow', 'height=500, width=500, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=n o, status=no')

                //   通过监听，父页面可以拿到子页面传递的token，父(前端页面)，子(小窗)
                window.addEventListener('message', function (e) {
                this.me(e.data).then(() => {
                this.setToken(e.data)
                }).catch(() => {
                this.setToken('')
                })
                }, false)
            },
        jump,
        getRandom() {
            this.imgUrl = window.IPConfig.IP + '/CodeRandomController/getVerify.do?' + Math.random()
        },
        handleLogin () {
            this.$refs.loginForm.validate(valid => {
                if (valid) {
                    this.loading = true;
                    this.loginForm.password = CryptoJS.encrypt(this.loginForm.password);
                    this.axios.post(window.IPConfig.IP + '/LoginController/login.do?userName=' + this.loginForm.username + '&passWord=' + this.loginForm.password + '&codeRandom=' + this.loginForm.codeRandom + '&VSystemId=' + this.$store.state.user.VSystemId).then((response) => {
                        if (response.status == 200) {
                            if (response.data.status == 200) {
                              var expireTime = response.data.attributes.principal.expireTime;
                              var nowtime = new Date().getTime();
                              if (expireTime<nowtime) {
                                this.$message.error("用户密码已过期!");
                              }
                                this.loading = false;
                                var roles = ['0']
                                // response.data.attributes.principal.VRoleName.forEach(item => {
                                response.data.attributes.principal.tbRoleVOList.forEach(item => {
                                    if (item.VRoleName && item.VRoleName == '个人用户') {
                                        roles = ['0']
                                    }
                                    // if (item.VRoleName && item.VRoleName == '机构用户') {
                                    //     roles.push('1')
                                    // }
                                })
                                response.data.attributes.roles = roles
                                setUser(JSON.stringify(response.data.attributes))
                                sessionStorage.setItem('exit', '0')
                                if ((navigator.userAgent.indexOf('MSIE') >= 0) && (navigator.indexOf('Opear') < 0)) {
                                    // IE
                                    if (window.history.length > 0) {
                                        if (!getTokenKey('url')) {
                                            window.history.back(-1)
                                        } else {
                                            removeTokenKey('url')
                                            this.jump('/education')
                                        }
                                    } else {
                                        removeTokenKey('url')
                                        this.jump('/education')
                                    }
                                } else {
                                    // 非IE
                                    if (navigator.userAgent.indexOf('Firefox') >= 0 || navigator.userAgent.indexOf('Opear') >= 0 || navigator.userAgent.indexOf('Safari') >= 0 || navigator.userAgent.indexOf('Chrome') >= 0 || navigator.userAgent.indexOf('WebKit') >= 0) {
                                        // 查看是否从其他页面跳转过来
                                        if (window.history.length > 1) {
                                            // 查看是否从不需要返回的页面跳转过来
                                            if (!getTokenKey('url')) {
                                                // 如果不是，跳转回上一页
                                                window.history.back(-1)
                                            } else {
                                                // 如果是，跳转到总首页
                                                removeTokenKey('url')
                                                // this.jump('/dashboard')
                                                this.jump('/index')
                                            }
                                        } else {
                                            removeTokenKey('url')
                                            this.jump('/education')
                                        }
                                    }
                                }
                            }else if(response.data.status == 715){
                              this.$message.error(response.data.msg);
                              this.$router.push({
                                path: 'resetPass',
                                query: {
                                  userName: this.loginForm.username,
                                  VUserId: response.data.obj
                                }
                              })
                            }else {
                                this.loginForm.password = CryptoJS.decrypt(this.loginForm.password);
                                this.$message.error(response.data.msg);
                                this.getRandom()
                                this.loading = false;
                            }
                        } else {
                            this.loading = false;
                        }
                    })
                } else {
                    return false;
                }
            })
        },
        change(idx) {
            $('#login-form').hide();
            $('#QRcode').show();
            this.title = this.List[idx].title;
            this.CodeUrl = this.List[idx].CodeUrl;
            this.subtit = this.List[idx].subtit
        },
        close() {
            $('#login-form').show();
            $('#QRcode').hide();
        }
    }
}
</script>

<style>
    .loginBox {
        /* width: 100%; */
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .login-QRcode {
        width: calc(100% - 6rem);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .login-QRcode > div {
        padding: 0.2rem;
        font-size: 0.18rem;
    }
    .BOX {
        width: 5.2rem;
    }
    #QRcode {
        display: none;
    }
    #QRcode .titleBox {
        font-size: 0.18rem;
        margin: 0.4rem auto;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    #QRcode .con {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    #QRcode .con > div {
        display: flex;
        flex-direction: row;
        margin: 0.2rem 0;
    }
    #QRcode .con > div > div {
        display: flex;
        flex-direction: column;
        margin-left: 0.2rem;
        align-items: center;
    }
    #QRcode .con > div > div span:first-child {
        margin-bottom: 0.1rem;
    }
    .login-container {
        width: 6rem;
        /* height: 4.5rem; */
        background: #fff;
        padding: 0.4rem;
        margin-bottom: .1rem;
    }
    .login-container .title-container {
        font-size: 0.18rem;
        margin-bottom: 0.4rem;
    }
    .login-container .outerDiv {
        padding-top: 0.1rem;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: flex-end;
    }
    /* 二维码 */
    .download-QRcode{
        width: 6rem;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
    }
    .QRcode-Img{
        width: 1.5rem;
    }
    .qrcode{
        width: 100px;
        height: 100px;
        border: 1px solid red;
    }
    #qrcode {
        display: inline-block;
    }
    #qrcode img {
        width: 1.5rem;
        height: 1.5rem;
        background-color: #fff;
        padding: .1rem;
    }
    #qrcodeIphone {
        display: inline-block;
    }
    #qrcodeIphone img {
        width: 1.5rem;
        height: 1.5rem;
        background-color: #fff;
        padding: .1rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/Login/login.vue